import React, { forwardRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol } from 'antd';
import { EyeFill, EarFill } from 'react-bootstrap-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ValidationSheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var customer = _ref.customer;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        id: "printable",
        children: [/*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 6,
            children: /*#__PURE__*/_jsx("img", {
              src: "drawables/emgl.png",
              style: {
                width: '90%'
              }
            })
          }), /*#__PURE__*/_jsxs(ACol, {
            span: 8,
            offset: 10,
            children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h5", {
              children: "FICHE DE VALIDATION"
            })]
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(ARow, {
          gutter: 8,
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 12,
            children: /*#__PURE__*/_jsx("div", {
              className: "pad cool-radius",
              style: {
                background: '#EEE',
                padding: '10px'
              },
              children: /*#__PURE__*/_jsxs(Descriptions, {
                column: 2,
                title: "Informations personnelles",
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  span: 2,
                  label: "RNC",
                  children: customer.rnc
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Pr\xE9nom",
                  children: customer.firstname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Nom",
                  children: customer.lastname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  span: 2,
                  label: "T\xE9l\xE9phone",
                  children: customer.mobile
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Date de naissance",
                  children: customer.medecine_questions == null ? '--' : moment(customer.medecine_questions.bday).format('DD/MM/YYYY')
                })]
              })
            })
          }), /*#__PURE__*/_jsxs(ACol, {
            span: 12,
            children: [/*#__PURE__*/_jsx("div", {
              className: "pad cool-radius",
              style: {
                background: '#EEE',
                padding: '10px'
              },
              children: /*#__PURE__*/_jsxs(ARow, {
                children: [/*#__PURE__*/_jsx(ACol, {
                  span: 18,
                  children: /*#__PURE__*/_jsxs(Descriptions, {
                    labelStyle: {
                      fontWeight: 'bold',
                      fontSize: '18px'
                    },
                    contentStyle: {
                      fontWeight: 'bold',
                      fontSize: '16px'
                    },
                    title: "Donn\xE9es groupage",
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: "Groupe",
                      children: customer.laboresult.group
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: "Rhesus",
                      children: customer.laboresult.rhesus
                    })]
                  })
                }), /*#__PURE__*/_jsx(ACol, {
                  span: 4,
                  children: /*#__PURE__*/_jsx("h1", {
                    style: {
                      fontSize: '58px'
                    },
                    children: customer.laboresult = !null ? customer.laboresult.group + '' + customer.laboresult.rhesus : '--'
                  })
                })]
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "pad cool-radius",
              style: {
                background: '#EEE',
                padding: '10px'
              },
              children: /*#__PURE__*/_jsxs(Descriptions, {
                labelStyle: {
                  fontWeight: 'bold',
                  fontSize: '16px'
                },
                contentStyle: {
                  fontWeight: 'bold',
                  fontSize: '14px'
                },
                title: "Param\xE8tres vitaux",
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Pouls",
                  children: customer.medecine_questions == null ? '--' : customer.medecine_questions.pulse
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "TA",
                  children: customer.medecine_questions == null ? '--' : customer.medecine_questions.systole + '/' + customer.medecine_questions.diastole + ' mmHg'
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Poids",
                  children: customer.medecine_questions == null ? '--' : customer.medecine_questions.poids + ' Kg'
                })]
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsxs("h5", {
              children: [/*#__PURE__*/_jsx(EarFill, {
                size: 24
              }), " AUDIO-TEST"]
            }), /*#__PURE__*/_jsxs(Descriptions, {
              title: "Capacit\xE9s auditives",
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: "CA Droite",
                children: customer.audioresult == null ? '--' : customer.audioresult.hcright
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "CA Gauche",
                children: customer.audioresult == null ? '--' : customer.audioresult.hcleft
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsxs("h5", {
              children: [/*#__PURE__*/_jsx(EyeFill, {
                size: 24
              }), " VISIO-TEST"]
            }), /*#__PURE__*/_jsxs(Descriptions, {
              title: "Accuit\xE9 visuelle de loin",
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Binoculaire",
                children: customer.optaresult == null ? '--' : customer.optaresult.binocular + '/10'
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Oeil droit",
                children: customer.optaresult == null ? '--' : customer.optaresult.rightsight + '/10'
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Oeil gauche",
                children: customer.optaresult == null ? '--' : customer.optaresult.leftsight + '/10'
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                span: 3,
                label: "Conclusion",
                children: [customer.optaresult == null && '--', customer.optaresult != null && customer.optaresult.conclusion == 0 && 'INAPTE', customer.optaresult != null && customer.optaresult.conclusion == 1 && 'APTE SANS CORRECTION', customer.optaresult != null && customer.optaresult.conclusion == 2 && 'APTE AVEC CORRECTION']
              })]
            })]
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            lg: 6,
            md: 6,
            sm: 6,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("h5", {
                children: "Le Medecin validant"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            className: "g-col-6",
            lg: 6,
            md: 6,
            sm: 6,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("h5", {
                children: "Le Candidat"
              })
            })
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
  });
});
export default ValidationSheet;